/* st48236 - changes for schedule payment */
import React, { useState, useEffect, useContext, useRef } from "react";
import { useLocation,useNavigate } from "react-router-dom";
import { Button, Carousel, Col, Collapse, Form, Modal, Row, Tab, Tabs, Spinner } from "react-bootstrap";
/* st48236 - changes for schedule payment */
import '../../src/styles/billingConfirmation.css';
import paymentConfirmImg from '../assets/images/Payment-Confirm/confirm.svg';
import paymentConfirmImgQ5 from '../assets/images/Payment-Confirm/confirm-Q5.svg';
import successArrow from '../assets/images/Payment-Confirm/Success-Arrow.svg';
import sendEmailIcon from '../assets/images/Payment-Confirm/Send-email.svg';
import printReceiptIcon from '../assets/images/Payment-Confirm/Send-Recipt.svg';
import downloadReceiptIcon from '../assets/images/Payment-Confirm/E-Recipt.svg';
/* st48236 - changes for schedule payment */
import { getApiService } from "../services/ApiService";
import { postApiService } from "../services/ApiService"; 
import { GetPayLoad } from "../services/PayLoadStorage"; 
import { toast } from 'react-toastify';
import { useReactToPrint } from "react-to-print"; /*enable print option in confirmation page - st48236 - start*/
import html2canvas from "html2canvas"; /*enable pdf download option in confirmation page - st48236 - start*/
import jsPDF from "jspdf"; /*enable pdf download option in confirmation page - st48236 - start*/
import { LanguageContext } from "../contexts/LanguageContext";
/* st48236 - changes for schedule payment */
import Cookies from 'js-cookie';
import parse from 'html-react-parser'; /* PMO0001499 - CHG0120586 - SD47534 */
import { postData } from "../services/EncryptService"; /* PMO0001499 - CHG0120586 - SD47534 */

/* st48236 - changes for schedule payment */
const Payload = GetPayLoad('PayLoad');
const baseUrl = process.env.REACT_APP_API_BASE_URL;
/* st48236 - changes for schedule payment */
const headers = {
			"X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
			"X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
			"X-Hps-Region": Payload?.region ?? Cookies.get("region") ?? "",
			"X-Hps-Carrier": Payload?.owning_carrier  ?? Cookies.get("owningCarrier") ?? ""
		};
const BillingConfirmation = () => {
	/* st48236 - changes for schedule payment */
	const { pageContent } = useContext(LanguageContext);
	const [billingContent, setBillingContent] = useState([]);
	const [genericContent, setGenericContent] = useState([]);
	const [emailModal, setEmailModal] = useState(false);
	const [isLoading, setLoading] = useState(false);
	const [emailInput, setEmailInput] = useState('');
	const [emailError, setEmailError] = useState('');
	const [enableEmailBtn, setenableEmailBtn] = useState('');
	const emailRef = useRef(null);
	/*enable print option in confirmation page - st48236 - start*/
	const contentRef = useRef();
	const [isContentReady, setContentReady] = useState(false); // st48236 - 508 compliance Track when all API responses are received
	const [apiCallsCompleted, setApiCallsCompleted] = useState(false); // st48236 - 508 compliance Track when all API calls are completed
	//const reactToPrintFn = useReactToPrint({ contentRef });
	const [isDownloading, setIsDownloading] = useState(false);
	const [isPrinting, setIsPrinting] = useState(false);
	const [isBtnLoading, setBtnLoading] = useState(false);
	
	/* PMO0001499 - CHG0120586 - SD47534 */
	const printFn = useReactToPrint({
		contentRef,
		onBeforePrint: () => new Promise((resolve) => {
			setIsPrinting(true);
			resolve();
		}),
		onAfterPrint: () => setIsPrinting(false)
	});
	const reactToPrintFn = () => {
		printFn();
	};
	/* PMO0001499 ends*/

	/*enable print option in confirmation page - st48236 - end*/
	const loc = useLocation();
	const navigate = useNavigate();
	const [caseInfo, setCaseInfo] = useState([]);
	useEffect(() => {
		if(!loc.state){navigate('/billing');}
		const targetCaseUrl = process.env.REACT_APP_API_CASE_INFO_ENDPOINT;
        /*getApiService(baseUrl, targetCaseUrl, { cim: Payload?.cim, apiSource: 'settings' }, headers)
		.then((response) => {
			if (response?.data && response?.data?.status == 'SUCCESS') {
				const result = response.data.data;
				setCaseInfo(response.data.data);
			}else{
				toast.error('Error - Case Information API Call - Something went wrong',response?.data?.message);
			}
		})
		.catch(error => {
			toast.error('Error - Case Information API Call - Something went wrong');
		});*/
		if (pageContent['billing-confirmation']) {
			setBillingContent(pageContent['billing-confirmation']);
		}

		if (pageContent?.generic) {
			setGenericContent(pageContent.generic);
		}
		setApiCallsCompleted(true); // st48236 - 508 compliance Mark API calls as completed 
	}, [pageContent]);
	
	const data = JSON.parse(JSON.stringify(loc.state));	
	/* PMO0001499 - CHG0120586 - SD47534 - added isPrinting and isDownloading in transactionDetails */
	const transactionDetails = [
		{ label: billingContent?.billing_confirmation_confirmation_num_txt ? billingContent?.billing_confirmation_confirmation_num_txt : 'Confirmation Number', value: (data) ? data.confirmationNumber : '' },
		{ label: billingContent?.billing_confirmation_date_txt ? billingContent?.billing_confirmation_date_txt : 'Date', value: (data) ? data.currentDate : '' },
		{ label: billingContent?.billing_confirmation_type_transaction_txt ? billingContent?.billing_confirmation_type_transaction_txt : 'Type of Transaction', value: (data) ? data.paymentType !== 'EFT' ? (Cookies.get('owningCarrier') === 'Q5' ? 'Debit' : 'CCD') : billingContent?.billing_confirmation_transaction_type_eft : '' },
		{ label: billingContent?.billing_confirmation_status_txt ? billingContent?.billing_confirmation_status_txt : 'Status', value: billingContent?.billing_confirmation_success_txt ? billingContent?.billing_confirmation_success_txt : 'Success', isStatus: true },
		{ label: billingContent?.billing_confirmation_schedulefor_txt ? billingContent?.billing_confirmation_schedulefor_txt : 'Scheduled For', value: (data)?data.scheduleDate:'' },
		...(isPrinting && Cookies.get('owningCarrier') === 'Q5' ? [{ label: billingContent?.billing_confirmation_printed_on_label ? billingContent?.billing_confirmation_printed_on_label : 'Printed On', value: new Date().toLocaleDateString() }] : []),
		...(isDownloading && Cookies.get('owningCarrier') === 'Q5' ? [{ label: billingContent?.billing_confirmation_download_on_label ? billingContent?.billing_confirmation_download_on_label : 'Downloaded On', value: new Date().toLocaleDateString() }] : []),
		{ label: billingContent?.billing_confirmation_amount_txt ? billingContent?.billing_confirmation_amount_txt : 'Payment Amount', value: (data)?data.paymentAmt:'' }
	];

	const actionButtons = [
		{ icon: sendEmailIcon, text: billingContent?.billing_confirmation_send_email_btn_txt, variant: 'outline-success' },
		{ icon: printReceiptIcon, text: billingContent?.billing_confirmation_print_receipt_text, variant: 'outline-success' },
		{ icon: downloadReceiptIcon, text: billingContent?.billing_confirmation_download_receipt_text, variant: 'primary' }
	];
	const validateEmail = (email) => {
		const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return pattern.test(email);
	};
	const handleEmailPopupClick = (e) => {
		if(e) e.preventDefault();
		setEmailInput('');
		setEmailError('');
		setEmailModal(true);
	};
	
	const handleClosePopupClick = (e) => {
		if(e) e.preventDefault();
		{			
			setEmailModal(false);
		}
	};

	
	const formatScheduleDate = (date) => {
        if (!date) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, "0");
        return year+'-'+month+'-'+day+" 00:00:00";
    };

	/** Enable Send Email button */
	const targetRuleValueUrl = process.env.REACT_APP_API_GET_PROGRAM_RULE_VALUE_ENDPOINT;
		getApiService(baseUrl, targetRuleValueUrl, { action: 'ByRule', rulename: 'ENABLE_SEND_EMAIL_OPTION', carrierCode: Cookies.get("owningCarrier") }, headers)
		.then((response) => {
			if (response?.data?.statusCode === 200) {
				const result = response.data.data;
				setenableEmailBtn(result);
			}
		})
		.catch(error => {
			console.log("Get rule value API Failure");
		});
	/** Enable Send Email button ends */
	
	const sendEmail = (email_id) => {
		let mailSent = false;
		setLoading(true);
		const payload = new FormData();
		const targetEmailUrl = process.env.REACT_APP_API_CARRIER_EMAIL_SEND_ENDPOINT;
		payload.append("region", Payload?.region);
		payload.append("carrier", Payload?.owning_carrier);
		payload.append("cim", Payload?.cim);
		payload.append("email", email_id);
		payload.append("type_cd", (data)?data.frequency:'OTP');
		payload.append("dependent_num", 0);
		payload.append("enrollment_id", 0);
		payload.append("transaction_date", (data)?data.scheduleDate:'');
		payload.append("transaction_amt", (data)?data.paymentAmt:'');
		payload.append("ConfirmationNumber", (data)?data.confirmationNumber:'');
		payload.append("account_name", (data)?data.auth_account_name:'');
		payload.append("account_type", (data)?data.paymentType !== 'EFT'?'CCD':'EFT':'');
		payload.append("last_4_digits", (data)?data.lastdigit:'');
		payload.append("email_subject", billingContent?.billing_confirmation_email_subject ? billingContent?.billing_confirmation_email_subject : 'Payment confirmation Email');
		payload.append("case_number", (data)?data.casenum:'');
		payload.append("list_bill_cim", (data)?data.cim:'');
		/* PMO0001499 - CHG0120586 - SD47534 */
		payload.append("site_cd", (Payload?.site_cd)?Payload?.site_cd:'');
		payload.append("language", (Cookies.get('lang'))?Cookies.get('lang'):'eng');
		/* PMO0001499 ends*/

		postData(baseUrl, targetEmailUrl, payload, headers)
			.then((response) => {
				setLoading(false);
				setEmailModal(false);
				if (response?.data && response?.data?.status === 'SUCCESS') {
					mailSent = true;
				}
			})
			.catch(error => {
				console.error(genericContent?.service_post_error ? genericContent?.service_post_error : 'Error - Email Send API:', error);
			})
			.finally(() => {
				setLoading(false);
				setEmailModal(false);
				if (mailSent) {
					toast.success(`${billingContent?.billing_confirmation_success_email_txt ? billingContent?.billing_confirmation_success_email_txt : 'Email sent successfully to '} ${email_id}`);
				} else {
					toast.error(genericContent?.service_post_error ? genericContent?.service_post_error : 'Something went wrong while sending the email. Please try again.');
				}
			});
	};

	const handleSendEmailClick = (e) => {
		if (e) e.preventDefault();
		const email_id = emailRef.current ? emailRef.current.value : '';
		if (!validateEmail(email_id)) {
			setEmailError(billingContent?.billing_confirmation_email_validation_txt ? billingContent?.billing_confirmation_email_validation_txt : 'Please enter a valid email address.');
			return;
		}
		setEmailError('');
		sendEmail(email_id);
	};
	/* st48236 - changes for schedule payment */

	/*enable pdf download option in confirmation page - st48236 - start*/
    const handleDownloadPDF = async () => {
        const content = contentRef.current; // Reference to the content to be captured
		if (!content) return;

		try {
			// Temporarily hide elements with the "no-pdf" class
			const elementsToHide = document.querySelectorAll(".noprintconfirmpagebtn, .nopdfconfirmpagebtn");
			elementsToHide.forEach((el) => (el.style.display = "none"));
			setBtnLoading(true); /* Show loading spinner while PDF is being generated */
	        setIsDownloading(true); 		/* PMO0001499 - CHG0120586 - SD47534 allow React re-renders */
	        await new Promise((resolve) => setTimeout(resolve, 100)); // delay to allow re-render

			// Capture the content as an image
			const canvas = await html2canvas(content, { scale: 2 });
			const imgData = canvas.toDataURL("image/png");			

			// Create a PDF and add the image
			const pdf = new jsPDF("p", "mm", "a4");
			const pdfWidth = pdf.internal.pageSize.getWidth();
			const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
			pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

			// Save the PDF
			pdf.save("BillingConfirmation.pdf");

			// Restore the hidden elements
			elementsToHide.forEach((el) => (el.style.display = ""));
			setBtnLoading(false); /* Hide loading spinner after PDF is generated */
	        setIsDownloading(false); /* PMO0001499 - CHG0120586 - SD47534reset download option after save */
		} catch (error) {
			setBtnLoading(false);
	        setIsDownloading(false); /* PMO0001499 - CHG0120586 - SD47534reset download option on error too */
			console.error("Error generating PDF:", error);
			toast.error("Failed to download PDF. Please try again.");
		}
    };
	/*enable pdf download option in confirmation page - st48236 - end*/

	/*st48236 - 508 compliance*/      
	// Mark content as ready
		   const [userInteracted, setUserInteracted] = useState(false);
				
				useEffect(() => {
				  const handleUserInteraction = () => {
					setUserInteracted(true);
				  };
				
				  // Listen for user interactions
				  document.addEventListener('click', handleUserInteraction);
				  document.addEventListener('keydown', handleUserInteraction);
				  
				  return () => {
					document.removeEventListener('click', handleUserInteraction);
					document.removeEventListener('keydown', handleUserInteraction);
				  };
				}, []);
				
				useEffect(() => {
				  let timeoutId;
				  
				  if (apiCallsCompleted && !isContentReady) {
					timeoutId = setTimeout(() => {
					  setContentReady(true);
					  
					  // Only auto-focus if user hasn't interacted
					  if (!userInteracted && contentRef.current) {
						requestAnimationFrame(() => {
						  contentRef.current.focus({ preventScroll: true });
						});
					  }
					}, parseInt(process.env.REACT_APP_READABILITY_TIMEOUT));
				  }
				  
				  return () => {
					if (timeoutId) clearTimeout(timeoutId);
				  };
				}, [apiCallsCompleted, isContentReady, userInteracted]);
	/*st48236 - 508 compliance*/
	
	return (
		<>
		<main
        role="main"
        tabIndex="-1" // Make the <main> tag focusable
        ref={contentRef} // Attach the ref to the <main> tag
		style={{ outline: 'none' }} // revmove border
        aria-label="Billing Summary"
    	>
			<Modal size="sm" show={emailModal} onHide={handleClosePopupClick}>
			<Modal.Header className={`multipleaccounts pb-4 ${Payload?.owning_carrier === 'Q5' ? 'mobile-close-btn' : ''}`} closeButton>
					<span tabIndex={0}>
						<h4>Email Confirmation</h4>
					</span>
				</Modal.Header>
				<Modal.Body>
					<div className="" id="qtip-0-content" aria-atomic="true">
						<p className="lh-base">{billingContent?.billing_confirmation_payment_receipt ? billingContent?.billing_confirmation_payment_receipt : 'Please confirm that you would like to email the payment receipt for '} <strong>{(data)?data.auth_account_name:''} (XXXX-{(data)?data.lastdigit:''}) {(data)?data.paymentType !== 'EFT'?'CCD':'EFT':''}</strong></p>
						<Form.Group className="form-group mb-3" controlId="emailInput">
						<Form.Label className="form-label">Email Address <span className="text-danger">*</span></Form.Label>
						<Form.Control
							className="form-control"
							type="text"
							placeholder={billingContent?.billing_confirmation_enter_email_placeholder ? billingContent?.billing_confirmation_enter_email_placeholder : 'Enter email address'}
							ref={emailRef}
							defaultValue={emailInput}
							onChange={() => { if (emailError) setEmailError(''); }}
								isInvalid={!!emailError}
							/>
							<Form.Control.Feedback type="invalid">{emailError}</Form.Control.Feedback>
						</Form.Group>
						<div className="d-flex justify-content-end gap-2 mt-3">
							{!isLoading && (
								<>
									{/* <button className="cancel-btn" style={{ width: '45%', borderRadius: '10px' }} onClick={() => handleClosePopupClick()}>Cancel</button>
									<button className="save-btn" style={{ width: '45%', borderRadius: '10px' }} onClick={() => handleSendEmailClick()}>Send</button> */}
						<div className="d-flex col-12 mb-3 justify-content-center" style={{ gap: '16px' }}>
							{/* Responsive button order for Q5 carrier, similar to ExpiryUpdateModal */}
							{Payload?.owning_carrier === 'Q5' ? (
								<>
									{/* Mobile/Tablet: Send top, Cancel bottom */}
									<div className="q5-switch-mobile-btns d-block d-lg-none">
										<input
											type="submit"
											aria-label="Send"
											className="me-3 btn btn-secondary btn-lg mt-4"
											value="Send"
											onClick={handleSendEmailClick}
										/>
										<input
											type="button"
											aria-label="Cancel"
											className="btn btn-outline-secondary btn-lg mt-4"
											value="Cancel"
											onClick={handleClosePopupClick}
										/>
									</div>
									{/* Large screens: Cancel first, Send second */}
									<div className="q5-switch-desktop-btns d-none d-lg-flex">
										<input
											type="button"
											aria-label="Cancel"
											className="me-3 btn btn-outline-secondary btn-lg mt-4"
											value="Cancel"
											onClick={handleClosePopupClick}
										/>
										<input
											type="submit"
											aria-label="Send"
											className="btn btn-secondary btn-lg mt-4"
											value="Send"
											onClick={handleSendEmailClick}
										/>
									</div>
								</>
							) : (
								<>
									<input
										type="button"
										aria-label="Cancel"
										className="me-3 btn btn-outline-secondary btn-lg mt-4"
										value="Cancel"
										onClick={handleClosePopupClick}
									/>
									<input
										type="submit"
										aria-label="Send"
										className="btn btn-secondary btn-lg mt-4"
										value="Send"
										onClick={handleSendEmailClick}
									/>
								</>
							)}
						</div>
						</>
							)}
							</div>
					</div>
				</Modal.Body>
			</Modal>
			<div className="container-fluid content-inner mt-n5 py-0" ref={contentRef}>
				<div className="row">
					<div className="col-md-12 col-xl-12">
						<div class="row">
							<div class="col-md-12">
								<div class="card" data-aos="fade-up" data-aos-delay="800">
									<div class="col-md-12 col-xl-12">
										<div class="row">
											<div class="" data-aos="fade-up" data-aos-delay="800">
												<div class="card-body mt-3 mb-4">

													<div class="col-12 paymemt-confrm" tabIndex={0}>
														{/* Payment Success Header */}
														<div class="text-center">
															<img src={Cookies.get('owningCarrier') === 'Q5' ? paymentConfirmImgQ5 : paymentConfirmImg} alt="Payment confirmed" className="img-fluid" />
															<h4 class="mb-2 mt-3 fw-semibold payment-success-title">{billingContent?.billing_confirmation_title_txt?billingContent?.billing_confirmation_title_txt:'Payment Successful!'}</h4>

															<p class="mt-2 mb-2 paymentprocess">
															{billingContent?.billing_confirmation_subtitle_txt?billingContent?.billing_confirmation_subtitle_txt:'Your payment has been processed successfully'}
															</p>
														</div>
														{/* Transaction Details */}
														<div className='mt-4 d-grid justify-content-center'>
															<div className="confrm-box rounded-4 p-3">
																<p className="mb-3 fw-semibold">{billingContent?.billing_confirmation_transaction_dtls_txt?billingContent?.billing_confirmation_transaction_dtls_txt:'Transaction Details'}</p>

																{transactionDetails.map((detail, index) => (
																	<div key={index} className="col-12 d-flex mt-2">
																		<div className="text-start col-6">
																			<label className="detail-label">{detail.label}</label>
																		</div>
																		<div className="text-end col-6 fw-semibold">
																			{detail.isStatus ? (
																				<button className="btn btn-success btn-sm confirmationbtn" tabIndex={-1}>
																					<i class="fe fe-check fe-11 me-1"></i>
																					{detail.value}
																				</button>
																			) : (
																				<label className="detail-value">{detail.value}</label>
																			)}
																		</div>
																	</div>
																))}
															</div>
															{/* Action Buttons */}
															<div className="col-12 d-flex mt-3">
																{/* PMO0001499 - CHG0120586 - SD47534 - enable send email button based on program rule */}
																<div className="noprintconfirmpagebtn col-6">
																	{enableEmailBtn !== '' && enableEmailBtn === 'true'  && (<button
																		className={`btn rounded printreceipticon ${Cookies.get('owningCarrier') === 'Q5' ? 'btn-primary' : 'btn-outline-success'}`}
																		onClick={() => handleEmailPopupClick()}
																	>
																		<i className="fe fe-mail fe-12"></i>
																		<span className="d-inline-block">{actionButtons[0].text}</span>
																	</button>)}
																	{isLoading && (
																		<div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
																			<Spinner animation="border" role="status" ></Spinner>
																			<div style={{ fontSize: "12px" }}>Please wait while processing your request...</div>
																		</div>
																	)} 
																</div> {/* PMO0001499 - CHG0120586 - SD47534 - ends */}
																<div className="noprintconfirmpagebtn col-6 text-end" > {/*enable print option in confirmation page  - st48236 - start*/}
																	<button
																		className={`btn rounded printreceipticon ${Cookies.get('owningCarrier') === 'Q5' ? 'btn-primary' : 'btn-outline-success'}`}
																		onClick={reactToPrintFn}
																	>
																		<i className="fe fe-printer fe-12"></i>
																		<span className="d-inline-block">{actionButtons[1].text}</span>
																	</button>
																</div>
															</div>
															<div className="noprintconfirmpagebtn nopdfconfirmpagebtn col-12 mt-3 d-grid mb-3">
															<button className={`nopdfconfirmpagebtn btn dwnbtn-lg ${Cookies.get('owningCarrier') === 'Q5' ? 'btn-outline-secondary' : 'btn-primary'}`}  onClick={handleDownloadPDF}> {/*enable pdf download option in confirmation page - st48236 - start*/}
																{Cookies.get('owningCarrier') !== 'Q5' && (
																	<i className="fe fe-download me-1"></i>
																)}
																<span className="d-inline-block">{actionButtons[2].text}</span>
															</button>
															{isBtnLoading && (
																<div tabIndex={0} style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
																	<Spinner animation="border" role="status" ></Spinner>
																	<div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
																</div>
															)}
															</div>
															{/* current placeholder */}
														</div>
														<div className='mt-4 d-grid justify-content-center'>
															{/* PMO0001499 - CHG0120586 - SD47534 - added disclaimer for Q5 */}
															{Cookies.get('owningCarrier') === 'Q5' && (
																<div className="disclaimer mt-2">
																	{billingContent?.billing_paybill_detail_disclaimer ? parse(billingContent?.billing_paybill_detail_disclaimer) : <p>{'Your default disclaimer text here.'}</p>}
																</div>
															)} {/* PMO0001499 ends*/}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</main>
		</>
	);
};

export default BillingConfirmation;